import React from "react";
import PropTypes from "prop-types";

import { Title } from "./Title";
import { Wrapper } from "./Wrapper";
import { NoButton } from "./NoButton";
import { YesButton } from "./YesButton";
import { HintsLeft } from "./HintsLeft";
import { TitleIcon } from "./TitleIcon";
import { ActionButtons } from "./ActionButtons";
import { Modal } from "@learningblocks/shared-components/lib/Modal";

export function HintModal(props) {
  return (
    <Modal className={`${props.className}`} isOpen={props.isOpen}>
      <Wrapper className="hintModal__wrapper">
        <TitleIcon className="hintModal__wrapper__titleIcon" />
        <Title className="hintModal__wrapper__title" message={props.message} />
        <HintsLeft
          className="hintModal__wrapper__hintsLeft"
          tabIndex={props.tabIndex}
          hintsLeft={props.hintsLeft}
        />
        <ActionButtons className="hintModal__wrapper__actionButtons">
          <NoButton
            className="hintModal__wrapper__actionButtons__noButton"
            onClickNo={props.onClickNo}
          />
          <YesButton
            className="hintModal__wrapper__actionButtons__yesButton"
            onClickYes={props.onClickYes}
          />
        </ActionButtons>
      </Wrapper>
    </Modal>
  );
}

HintModal.propTypes = {
  /**
   * Number of hints left
   */
  hintsLeft: PropTypes.number,
  /**
   * callback for yes button
   */
  onClickYes: PropTypes.func,
  /**
   * callback for no button
   */
  onClickNo: PropTypes.func,
  /**
   * Hint modal title message
   */
  message: PropTypes.string,
  /**
   * child elements to be enclosed in modal
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

HintModal.defaultProps = {
  className: "",
};
